
    /* eslint-disable */
    // @ts-nocheck
    // @ts-ignore
    var __STORY__ = "import featured from './data/featured.json';\nimport recent from './data/recent.json';\nimport topics from './data/topics.json';\nimport examplePrototype from './example/example.twig';\nimport './example/example.scss';\n\nexport default {\n  title: 'Prototypes/Article Listing',\n  parameters: {\n    docs: { page: null },\n    layout: 'fullscreen',\n  },\n};\n\nexport const Example = () => examplePrototype({ recent, featured, topics });\n";
    // @ts-ignore
    var __LOCATIONS_MAP__ = {"Example":{"startLoc":{"col":23,"line":15},"endLoc":{"col":75,"line":15},"startBody":{"col":23,"line":15},"endBody":{"col":75,"line":15}}};
    
import featured from './data/featured.json';
import recent from './data/recent.json';
import topics from './data/topics.json';
import examplePrototype from './example/example.twig';
import './example/example.scss';

export default {
  title: 'Prototypes/Article Listing',
  parameters: {
    docs: { page: null },
    layout: 'fullscreen',
  },
};

export const Example = () => examplePrototype({ recent, featured, topics });



Example.parameters = { storySource: { source: "() => examplePrototype({ recent, featured, topics })" }, ...Example.parameters };